import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '../../../section';
import { NestedComponentRenderer } from '../../NestedComponentRenderer';

interface NarrowSectionProps {
  data: Queries.NarrowSectionFragment;
}

export const NarrowSection = ({
  data: { background, components, narrowSectionId },
  ...rest
}: NarrowSectionProps) => (
  <Section
    background={background === 'Background'}
    narrow
    id={narrowSectionId}
    {...rest}
  >
    <NestedComponentRenderer components={components} />
  </Section>
);

export const NarrowSectionQuery = graphql`
  fragment NarrowSection on UMBRACO_NarrowSectionComponentType {
    background
    narrowSectionId
    components {
      ...Accordion
      ...NestedComponents
    }
  }
`;
